import { useState } from "react";
import {
    createReportSubGroupAsync,
    updateReportSubGroupAsync,
    enableReportSubGroupAsync,
    disableReportSubGroupAsync,
} from "@features/report/subgroup/services/reportSubGroupSvc";
import {
    CreateReportSubGroupRequest,
    UpdateReportSubGroupRequest,
} from "@features/report/subgroup/types/reportSubGroupRequests";

export function useReportSubGroupActions() {
    const [busy, setBusy] = useState(false);

    const doSubGroupCreate = async (
        nationId: number,
        data: CreateReportSubGroupRequest
    ) => {
        setBusy(true);
        const response = await createReportSubGroupAsync(nationId, data);
        setBusy(false);
        return response;
    };

    const doSubGroupUpdate = async (
        nationId: number,
        reportSubGroupId: number,
        data: UpdateReportSubGroupRequest
    ) => {
        setBusy(true);
        const response = await updateReportSubGroupAsync(
            nationId,
            reportSubGroupId,
            data
        );
        setBusy(false);
        return response;
    };

    const doSubGroupDisable = async (nationId: number, reportSubGroupId: number) => {
        setBusy(true);
        const response = await disableReportSubGroupAsync(nationId, reportSubGroupId);
        setBusy(false);
        return response;
    };

    const doSubGroupEnable = async (nationId: number, reportSubGroupId: number) => {
        setBusy(true);
        const response = await enableReportSubGroupAsync(nationId, reportSubGroupId);
        setBusy(false);
        return response;
    };

    return { busy, doSubGroupCreate, doSubGroupUpdate, doSubGroupDisable, doSubGroupEnable };
}
